import { useEffect, useSyncExternalStore } from "react";
import { api } from "@/lib/api";

// Admin-only Stripe fee model (auto-updated server-side from real Stripe data). Same maths as backend marketplace/fees.py.
const VAT = 0.2;
const r2 = (x) => Math.floor(x * 100 + 0.5 + 1e-9) / 100;
let model = null;
let loading = null;
const listeners = new Set();
const emit = () => listeners.forEach((l) => l());

export function loadFeeModel(force = false) {
  if ((model && !force) || loading) return loading;
  loading = api.get("/admin/fees/model").then(({ data }) => {
    model = data;
    emit();
    return data;
  }).catch(() => null).finally(() => {
    loading = null;
  });
  return loading;
}

export const setFeeModel = (m) => {
  model = m;
  emit();
};

export const useFeeModel = (enabled = true) => {
  useEffect(() => {
    if (enabled) loadFeeModel();
  }, [enabled]);
  return useSyncExternalStore((l) => (listeners.add(l), () => listeners.delete(l)), () => model);
};

export function estimate(rates, ht, currency = "eur", usdRate = 1) {
  const region = currency === "eur" ? "eea" : "intl";
  const ttc = r2(ht * (1 + VAT));
  const vat = r2(ttc - ht);
  const fixed = rates[`${region}_fixed`] * (currency === "usd" ? usdRate : 1);
  const card = r2((ttc * rates[`${region}_pct`]) / 100 + fixed + (currency !== "eur" ? (ttc * rates.fx_pct) / 100 : 0));
  const managed = r2((ttc * rates.managed_pct) / 100);
  const billing = r2((ttc * rates.billing_pct) / 100);
  return { ttc, vat, card, managed, billing, net: r2(ttc - vat - card - managed - billing) };
}
